import areas from './areas';

export default function*(){
    yield* [...areas];
}